export default __webpack_public_path__ + "static/media/beep-09.7d5812cb.mp3";